import axios from "../customAxios";
import { PDFDocument } from "pdf-lib";
import { dateToDatabase } from "./functions";
import { getPublicS3Url } from "./s3Utils";

const getMode = (user) => {
  if (user.user_type.includes("admin")) {
    return "admin";
  } else if (user.user_type.includes("operator")) {
    return "operator";
  } else if (user.user_type.includes("seller")) {
    return "seller";
  } else {
    return null;
  }
};

export const getSelectedLabels = async (selected, user) => {
  const payload = {
    mode: getMode(user),
    selectedLabels: selected,
  };

  try {
    const {
      data: { deliveries, delivery_items_collection: deliveryItems },
    } = await axios.post("api/get-selected-deliveries/", payload);

    const labelUrls = deliveryItems
      .map((item) => {
        if (item?.label) {
          try {
            const url = new URL(item.label);
            const s3Key = url.pathname.substring(1);

            // Construct public URL
            return getPublicS3Url(process.env.REACT_APP_S3_BUCKET_NAME, s3Key);
          } catch (parseError) {
            console.error(
              `Error al convertir url: ${item.label} ${parseError}`,
            );
            return null;
          }
        }
        return null;
      })
      .filter((url) => url !== null);

    return labelUrls;
  } catch (error) {
    console.error(`Error al obtener las url de etiquetas: ${error}`);
    throw error;
  }
};

export const getLabelsUrl = async (filters, user) => {
  const params = {
    start_date: dateToDatabase(filters.startDate),
    end_date: dateToDatabase(filters.endDate),
    company: filters.companyFilter,
    search: filters.search,
    delivery_status: filters.statusFilter,
    page: filters.page,
    rowsPerPage: filters.rowsPerPage,
    mode: getMode(user),
    orderFilter: filters.orderFilter,
    orderByFilter: filters.orderByFilter,
  };

  try {
    const {
      data: { deliveries, delivery_items_collection: deliveryItems },
    } = await axios.get("api/delivery-resume/", { params });

    const labelUrls = deliveryItems
      .map((item) => {
        if (item?.label) {
          try {
            const url = new URL(item.label);
            const s3Key = url.pathname.substring(1);

            // Construct public URL
            return getPublicS3Url(process.env.REACT_APP_S3_BUCKET_NAME, s3Key);
          } catch (parseError) {
            console.error(
              `Error al convertir url: ${item.label} ${parseError}`,
            );
            return null;
          }
        }
        return null;
      })
      .filter((url) => url !== null);

    return labelUrls;
  } catch (error) {
    console.error(`Error al obtener las url de etiquetas: ${error}`);
    throw error;
  }
};

export const mergePDFSFromUrls = async (urls) => {
  // validate urls
  if (!urls || urls.length === 0) {
    return null;
  }

  // download pdfs
  const pdfBytesArray = await Promise.all(
    urls.map((url) => fetch(url).then((response) => response.arrayBuffer())),
  );

  // merge pdfs
  const mergedPDFDoc = await PDFDocument.create();
  for (const pdfBytes of pdfBytesArray) {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const copiedPages = await mergedPDFDoc.copyPages(
      pdfDoc,
      pdfDoc.getPageIndices(),
    );
    copiedPages.forEach((page) => mergedPDFDoc.addPage(page));
  }

  const mergedPdfBytes = await mergedPDFDoc.save();
  return new Blob([mergedPdfBytes], { type: "application/pdf" });
};
